import React from 'react';
import { connect } from 'react-redux';
import { withStyles } from '@material-ui/core/styles';
import CloseIcon from '@material-ui/icons/Close';
import DeleteIcon from '@material-ui/icons/Delete';
import FullscreenIcon from '@material-ui/icons/Fullscreen';
import CheckBoxIcon from '@material-ui/icons/CheckBox';
import PrintIcon from '@material-ui/icons/Print';
import PrintDisabledIcon from '@material-ui/icons/PrintDisabled';
import CheckIcon from '@material-ui/icons/Check';
import PlusIcon from '@material-ui/icons/Add'
import RemoveIcon from '@material-ui/icons/Remove'
import Modal from 'shared/components/Modal';
import modalStyles from 'shared/components/modalStyles';
import messages, { FormattedMessage } from 'shared/messages/messages';

import {
  setPhotoSwipeOpen,
  setPhotoSwipeMoment
} from 'app/actions/photoSwipeActions';

import {
  selectPrints,
  unselectPrints
} from 'shared/actions/cartActions';

import {
  selectPrePrints,
  unSelectPrePrints,
  viewVideo
} from 'app/actions/kioskActions';

import {
  trackEvent
} from 'shared/services/Analytics';

import { getAspectRatio } from 'app/utils/Utils';

import {
  MULTI_PRINT_MODE,
  LEGACY_PRINT_MODE,
  SIZED_PRINT_MODE
} from 'shared/utils/Constants';

import KioskService from 'app/services/KioskService';

import ImagePrintSizeSelection from './ImagePrintSizeSelection';
const isViewPhotosItem = localStorage.getItem('VIEW_PHOTOS');
const isViewPhotos = isViewPhotosItem === 'false' || !isViewPhotosItem ? false : true;

const styles = () => ({
  fullscreenIcon: {
    position: 'absolute',
    zIndex: 1,
    bottom: 0,
    fontSize: '2.5rem',
    textShadow: '1px 1px 3px rgba(0, 0, 0, 0.3)',
    color: '#fff',
    cursor: 'pointer',
    background: 'rgba(0, 0, 0, 0.8)',
    borderRadius: '3px',
    margin: '0.3rem',
    padding: '0.1rem'
  },
  aspRLabel: {
    position: 'absolute',
    zIndex: 1,
    top: 0,
    right: 0,
    fontSize: '1.5rem',
    textShadow: '1px 1px 3px rgba(0, 0, 0, 0.3)',
    color: '#fff',
    cursor: 'pointer',
    background: 'rgba(0, 0, 0, 0.8)',
    borderRadius: '3px',
    margin: '0.3rem',
    padding: '0.1rem',
  },
  accessCodeLabel: {
    position: 'absolute',
    zIndex: 1,
    top: 0,
    fontSize: '1.5rem',
    textShadow: '1px 1px 3px rgba(0, 0, 0, 0.3)',
    color: '#fff',
    cursor: 'pointer',
    background: 'rgba(0, 0, 0, 0.8)',
    borderRadius: '3px',
    margin: '0.3rem',
    padding: '0.1rem',
    whiteSpace: 'pre-wrap'
  },
  waypoint: {
    //position: 'relative'
    position: 'absolute',
    left: 0,
    top: '-10vh'
  },
  removeIcon: {
    position: 'absolute',
    zIndex: 1,
    top: 0,
    color: '#fff',
    fontSize: '2.3rem',
    textShadow: '1px 1px 3px rgba(0, 0, 0, 0.3)',
    cursor: 'pointer',
    background: 'rgba(0, 0, 0, 0.8)',
    borderRadius: '3px',
    margin: '0.3rem'
  },
  selectIcon: {
    position: 'absolute',
    zIndex: 1,
    top: 0,
    left: 0,
    color: '#fff',
    fontSize: '2.5rem',
    textShadow: '1px 1px 3px rgba(0, 0, 0, 0.3)',
    cursor: 'pointer',
    background: 'rgba(0, 0, 0, 0.8)',
    borderRadius: '3px',
    margin: '0.3rem',
    padding: '0.2rem'
  },
  printIcon: {
    position: 'absolute',
    zIndex: 1,
    bottom: 0,
    color: '#fff',
    fontSize: '2.5rem',
    textShadow: '1px 1px 3px rgba(0, 0, 0, 0.3)',
    cursor: 'pointer',
    borderRadius: '3px',
    margin: '0.3rem',
    padding: '0.2rem',
    background: '#ffbc00'
  },
  sizeSelectIcon: {
    position: 'absolute',
    zIndex: 1,
    bottom: 0,
    right: '45px',
    color: '#fff',
    fontSize: '2.5rem',
    textShadow: '1px 1px 3px rgba(0, 0, 0, 0.3)',
    cursor: 'pointer',
    background: '#ffbc00',
    borderRadius: '3px',
    margin: '0.3rem 0',
    padding: '0.1rem'
  },
  countLabel: {
    position: 'absolute',
    zIndex: 1,
    bottom: 0,
    right: 0,
    color: '#fff',
    fontSize: '1.6em',
    width: '1.7em',
    textShadow: '1px 1px 3px rgba(0, 0, 0, 0.3)',
    cursor: 'pointer',
    background: 'rgba(0, 0, 0, 0.8)',
    borderRadius: '3px',
    margin: '0.3rem',
    padding: '0.1rem'
  },
  plusIcon: {
    position: 'absolute',
    zIndex: 1,
    bottom: 0,
    right: '96px',
    color: '#fff',
    fontSize: '2.5rem',
    textShadow: '1px 1px 3px rgba(0, 0, 0, 0.3)',
    cursor: 'pointer',
    background: 'rgba(0, 0, 0, 0.8)',
    borderRadius: '3px',
    margin: '0.3rem 0',
    padding: '0.1rem'
  },
  minusIcon: {
    position: 'absolute',
    zIndex: 1,
    bottom: 0,
    right: '52px',
    color: '#fff',
    fontSize: '2.5rem',
    textShadow: '1px 1px 3px rgba(0, 0, 0, 0.3)',
    cursor: 'pointer',
    background: 'rgba(0, 0, 0, 0.8)',
    borderRadius: '3px',
    margin: '0.3rem 0',
    padding: '0.1rem'
  },
  videoWrapper: {
    position: 'relative',
    '&::before': {
      content: ' ',  // Add the print emoji or any other content before the button's text
      position: 'absolute',
      backgroundColor: 'red',
      right: '20px',
      bottom: '20px',
      width: '50px',
      height: '50px'
    }
  },
  ...modalStyles()
});

class Image extends React.Component {
  constructor(props) {
    super(props);

    const { settings } = props;

    this.state = {
      visible: true,
      showRemoveModal: false,
      multiPrint: settings.print_mode === MULTI_PRINT_MODE,
      legacyPrint: settings.print_mode === LEGACY_PRINT_MODE,
      sizedPrint: settings.print_mode === SIZED_PRINT_MODE,
      showPrintSizeSelect: false,
      momentPrintSizes: []
    }
  }

  selected(props) {
    props = props || this.props;
    const { selectedMomentIds, attrs: { photo: { moment_id } } } = props;

    return selectedMomentIds.indexOf(moment_id) !== -1;
  }

  printToggled(props) {
    props = props || this.props;

    const {
      selectedPrintMomentIds,
      selectedPrePrintMomentIds,
      attrs: { photo: { moment_id } }
    } = props;

    let allPrints = selectedPrintMomentIds.concat(selectedPrePrintMomentIds)

    return allPrints.indexOf(moment_id) !== -1;
  }

  printCount(props) {
    props = props || this.props;

    const {
      selectedPrintMomentIds,
      selectedPrePrintMomentIds,
      attrs: { photo: { moment_id } }
    } = props;

    let allPrints = selectedPrintMomentIds.concat(selectedPrePrintMomentIds)

    return allPrints.filter(id => id === moment_id).length;
  }

  viewImage() {
    const { attrs: { photo } } = this.props;
    let moment = { id: photo.moment_id, purchased: photo.purchased };
    if (photo.type && photo.type.includes('video')) {
      this.props.viewVideo(true, photo);
    } else {
      this.props.setPhotoSwipeMoment(moment);
      this.props.setPhotoSwipeOpen(true);
    }
  }

  showRemoveModal() {
    if (this.props.showRemoveModal) {
      this.setState({ showRemoveModal: true });
    } else {
      this.remove();
    }
  }

  closePrintSizeSelectModal() {
    window.currentModal && window.currentModal.close();
    this.setState({ showPrintSizeSelect: false });
  }

  closeRemoveModal() {
    window.currentModal && window.currentModal.close();
    setTimeout(() => {
      this.setState({ showRemoveModal: false });
    });

    document.body.style.overflowY = 'scroll';
  }

  remove() {
    const { removeImage, attrs: { photo } } = this.props;
    removeImage(photo.moment_id);
    this.closeRemoveModal();
  }

  select() {
    const {
      attrs: { photo: { moment_id, purchased } }, onSelect
    } = this.props;

    if (!isViewPhotos) {
      onSelect(moment_id, purchased);
    }
  }

  unselect() {
    const { onUnselect, attrs: { photo: { moment_id } } } = this.props;
    if (!isViewPhotos) {
      return onUnselect(moment_id);
    }
  }

  toggleSelected() {
    // generally tapping the image once selects the digital,
    // then tapping it a second time selects the print,
    // then a third time disables the print and the digital.
    // if print sizes are enabled, this would cause the print size modal
    // to open and this would prevent disabling the digital.
    // so for print sizes togglePrint will be ignored here
    // and the user will have to tap the print icon
    const { attrs: { photo }, printsEnabled, cart } = this.props;
    const { sizedPrint } = this.state;

    // If the the kiosk is in PrePrint mode, only add the selection to redux
    if (isViewPhotos) {
      this.addPrint();
      return;
    }

    // if the photo has been purchased or this is the cart screen,
    // then toggle the print instead of the digital
    // unless print sizes are enabled,
    // in which case do nothing
    if (photo.purchased || cart) {
      if (printsEnabled && !sizedPrint) {
        return this.togglePrint();
      } else {
        return;
      }
    }

    if (this.selected()) {
      if (!printsEnabled || this.printToggled() || sizedPrint) {
        this.unselect();

      } else if (!sizedPrint) {
        this.enablePrint();
      }
    } else {
      this.select();
    }
  }

  onPrintIconClick() {
    // if print sizes are enabled then open the print size modal,
    // otherwise toggle off (disable) the print
    if (this.state.sizedPrint && !isViewPhotos) {
      this.selectMomentPrintSize();
    } else {
      this.disablePrint();
    }
  }

  addPrint() {
    const {
      settings,
      user,
      selectPrints,
      selectPrePrints,
      printsEnabled,
      attrs: { photo: { moment_id } }
    } = this.props;

    if (this.props.attrs.photo.print_purchased && !printsEnabled) {
      return;
    }

    if (isViewPhotos) {
      selectPrePrints([moment_id]);
    } else {
      let v2 = true;
      selectPrints(user.story_id, [moment_id], v2);
    }

    trackEvent('Kiosk.AddPrint', {
      userId: user.id,
      storyId: user.story_id,
      kiosk: settings.token,
      momentId: moment_id
    });
  }

  subtractPrint() {
    const {
      settings,
      user,
      unselectPrints,
      unSelectPrePrints,
      printsEnabled,
      attrs: { photo: { moment_id } }
    } = this.props;

    if (this.props.attrs.photo.print_purchased && !printsEnabled) {
      return;
    }

    if (this.printCount() !== 1) {
      if (isViewPhotos) {
        unSelectPrePrints([moment_id]);
      } else {
        let v2 = true;
        unselectPrints(user.story_id, [moment_id], v2);
      }
    } else {
      this.disablePrint();
    }

    trackEvent('Kiosk.SubtractPrint', {
      userId: user.id,
      storyId: user.story_id,
      kiosk: settings.token,
      momentId: moment_id
    });
  }

  async enablePrint() {
    const {
      settings,
      user,
      attrs: { photo: { purchased, print_purchased, moment_id } }
    } = this.props;

    // If the the kiosk is in PrePrint mode, only add the selection to redux
    if (isViewPhotos) {
      this.addPrint();
      return;
    }

    if (print_purchased && !this.state.printModeEnabled) {
      return;
    }

    if (!purchased && !this.selected()) {
      this.select();
    }


    // if sized prints are enabled then open the print size dialog
    if (this.state.sizedPrint) {
      this.selectMomentPrintSize();
      return;
    }

    this.addPrint();

    trackEvent('Kiosk.SelectPrint', {
      userId: user.id,
      storyId: user.story_id,
      kiosk: settings.token,
      momentId: moment_id
    });
  }

  async disablePrint() {
    const {
      settings,
      user,
      unselectPrints,
      unSelectPrePrints,
      printsEnabled,
      attrs: { photo: { purchased, print_purchased, moment_id } },
      cart
    } = this.props;

    const { sizedPrint } = this.state;

    if (print_purchased && !printsEnabled) {
      return;
    }

    // on the View Gallery page, the user taps once to select digital and
    // taps a 2nd time to select a print. tapping a 3rd time then unselects both.
    // on the Cart page, tapping only selects and unselects prints.
    // so if this is the gallery page, then we'll want to call unselectMoments,
    // which will unselect both the digital and print.
    // if this is the cart page then we just want to unselect the print.
    // also if the digital has been purchased then we just want to unselect the print.
    // there is an exception here for if print sizes are enabled,
    // as tapping the image in this case doesn't toggle the prints,
    // and unselecting the print shouldn't unselect the digital
    // (except for an edge case with purchased moments,
    // which is handled in ImagePrintSizeSelection.removePrints)

    if (isViewPhotos) {
      unSelectPrePrints([moment_id]);
    } else {
      if (cart || purchased) {
        await unselectPrints(user.story_id, [moment_id]);
      } else if (!sizedPrint) {
        // this is the gallery view and print sizes aren't enabled
        await this.unselect();
      }
    }

    trackEvent('Kiosk.UnselectPrint', {
      userId: user.id,
      storyId: user.story_id,
      kiosk: settings.token,
      momentId: moment_id
    });
  }

  togglePrint() {
    if (this.printToggled()) {
      this.disablePrint();
    } else {
      this.enablePrint();
    }
  }

  renderRemoveModal() {
    const { classes } = this.props;

    let slide = (
      <div className={classes.modalSlide}>
        <p className={classes.modalText}>
          <FormattedMessage {...messages.kiosk_remove_modal_instructions} />
        </p>
      </div>
    );

    return (
      <Modal disableScrollbar={true}
        isOpen={this.state.showRemoveModal}
        close={this.closeRemoveModal.bind(this)}>
        <div className={classes.modalOverlay} onClick={this.closeRemoveModal.bind(this)}></div>
        <div className={classes.modal}>
          <CloseIcon className={classes.modalCloseIcon} onClick={this.closeRemoveModal.bind(this)} />
          <div className={classes.modalStage}>
            <div className={classes.modalSlider}>
              {slide}
            </div>
          </div>
          <div className={classes.modalButtons}>
            <button className={classes.modalButtonWhite} onClick={this.closeRemoveModal.bind(this)} style={{ width: '50%', marginTop: '1.5rem' }}>
              <FormattedMessage {...messages.button_cancel} />
            </button>
            <button className={classes.modalButton} onClick={this.remove.bind(this)} style={{ width: '50%', marginTop: '1.5rem' }}>
              <FormattedMessage {...messages.button_remove} />
            </button>
          </div>
        </div>
      </Modal>
    );
  }

  renderSizeSelectionModal(momentId, width, height, thumbUrl, purchased) {
    return (
      <ImagePrintSizeSelection
        isOpen={this.state.showPrintSizeSelect}
        momentId={momentId}
        momentWidth={width}
        momentHeight={height}
        onClose={() => this.closePrintSizeSelectModal()}
        thumbUrl={thumbUrl}
        purchased={purchased}
        momentPrintSizes={this.state.momentPrintSizes}
      />
    )
  }

  selectMomentPrintSize() {
    const { settings, attrs: { photo: { moment_id } } } = this.props;
    KioskService.getMomentPrintSizes(settings.kiosk_id, moment_id).then((momentPrintSizes) => {
      this.setState({ momentPrintSizes: momentPrintSizes });
      this.setState({ showPrintSizeSelect: true });
    });
  }

  render() {
    const {
      classes,
      attrs,
      resolution,
      selectEnabled,
      removeEnabled,
      settings,
      user,
      printsEnabled,
      displayAccessCodes,
      attrs: { photo: { width, height } }
    } = this.props;

    const { visible, multiPrint, sizedPrint } = this.state;
    const selected = selectEnabled && this.selected();
    const printCount = this.printCount();
    const isVideo = typeof attrs.photo.type === 'string' && !!attrs.photo.type.match(/video/);
    let showPrintToggled = false;


    if (printsEnabled) {
      showPrintToggled = this.printToggled() ||
        (user.unlocked && attrs.photo.print_purchased && !multiPrint && !sizedPrint);
    }

    const Checkmark = ({ selected, printToggled, purchased }) => {
      let checkboxStyle = {
        position: 'absolute',
        left: '-0.2rem',
        top: '-0.2rem',
        margin: '0.5rem',
        zIndex: 4,
        fontSize: '2.5rem',
        color: 'rgba(255, 255, 255, 0.9)'
      }

      // for some reason the catalog screen needs a margin of 0.4rem
      if (this.props.checkboxStyle) {
        checkboxStyle = {
          ...checkboxStyle,
          ...this.props.checkboxStyle
        }
      }

      if (selected) {
        checkboxStyle.color = 'rgb(0 174 230)';

        let checkboxBgStyle = {
          position: 'absolute',
          zIndex: 3,
          margin: '0.6rem',
          background: '#fff',
          width: '1.7rem',
          height: '1.7rem',
          borderRadius: '1rem'
        }

        if (printToggled) {
          checkboxBgStyle.margin = 0;
        }

        return (
          <div onClick={() => this.toggleSelected()}>
            <div style={checkboxBgStyle} />
            <CheckBoxIcon style={checkboxStyle} />
          </div>
        );
      } else if (purchased) {
        checkboxStyle.cursor = 'default';

        if (printToggled) {
          checkboxStyle.margin = '18px';
        }

        let tooltip = <FormattedMessage {...messages.kiosk_cart_image_tooltip_digital_purchased} />;

        return <CheckIcon style={checkboxStyle} title={tooltip} />;

      } else {
        return <CheckBoxIcon style={checkboxStyle} onClick={() => this.toggleSelected()} />;
      }
    }

    const AspectRatioLabel = ({ width, height, classes, style }) => {
      const aspectLabel = getAspectRatio(width, height);
      return <div className={classes.aspRLabel} style={style}><label style={{ marginBottom: "0rem" }}>{aspectLabel}</label></div>
    }

    const AccessCodeLabel = ({ classes, customers }) => {
      const acLabel = customers.map(c => {
        return c.access_code
      }).join("\n")
      return <div className={classes.accessCodeLabel}><label style={{ marginBottom: "0rem" }}>{acLabel}</label></div>
    }

    const imgStyle = {
      width: '100%',
      height: '100%',
      border: '6px solid #fff',
      borderRadius: '3px',
      background: '#fff'
    };

    const selectedImgStyle = {
      transform: "translateZ(0px) scale3d(0.9, 0.9, 1)",
      border: '8px solid #57d6ff'
    };

    let cont = {
      width: '100%',
      height: '100%',
      cursor: "pointer",
      overflow: "hidden",
      position: "relative",
      //opacity: visible ? 1 : 0,
      borderRadius: '3px',
      margin: '2px',
      background: '#fff'
    };

    //if (selected) {
    //  cont.background = '#fff';
    //}

    if (attrs.direction === "column") {
      cont.position = "absolute";
      cont.left = attrs.left;
      cont.top = attrs.top;
    }

    let fsIconStyle = {};
    if (multiPrint || sizedPrint) {
      fsIconStyle.left = 0;
    } else {
      fsIconStyle.right = 0;
    }

    let fullscreenIcon = (
      <FullscreenIcon className={classes.fullscreenIcon} style={fsIconStyle} onClickCapture={this.viewImage.bind(this)} />
    );

    let img = null;
    if (visible) {
      var src = "";
      switch (resolution) {
        case 0:
          src = attrs.photo.thumb_url;
          break;

        case 1:
          src = attrs.photo.thumb_url_large;
      }

      let onClick;
      if (this.props.viewImageOnTap) {
        onClick = () => this.viewImage();
      } else {
        onClick = () => this.toggleSelected();
      }

      img = (
        isVideo ?
          <video style={
            selected ? { ...imgStyle, ...selectedImgStyle } : { ...imgStyle }
          } src={attrs.photo?.original}
            onClick={onClick} controls />
          : <img
            title={attrs.photo.moment_id}
            style={
              selected ? { ...imgStyle, ...selectedImgStyle } : { ...imgStyle }
            }
            src={src}
            onClick={onClick}
          />
      );
    }

    let checkmark = null;
    if (selectEnabled && visible && !attrs.photo.purchased && !this.props.cart) {
      checkmark = (<Checkmark selected={selected} printToggled={showPrintToggled} purchased={attrs.photo.purchased} />);
    }

    // if the story has been unlocked,
    // then allow unlocked images to be removed from the gallery,
    // unless they were tagged to the customer (not added via More Photos).
    // if the story hasn't been unlocked then prevent removing
    // purchased images.
    let removeIcon = null;
    if (removeEnabled) {
      let showRemoveIcon = visible &&
        (user.unlocked || !attrs.photo.purchased) &&
        !attrs.photo.tagged;

      if (showRemoveIcon) {
        let style = {};
        if (selectEnabled) {
          style.right = 0;
        } else {
          style.left = 0;
        }

        removeIcon = (
          <DeleteIcon className={classes.removeIcon} style={style} onClick={this.showRemoveModal.bind(this)} />
        );
      }
    }

    let aspRLabel = null;
    if (settings.show_aspect && printsEnabled) {
      let rmStyle = {};
      if (removeIcon && selectEnabled) {
        rmStyle.top = "2.5rem";
      }

      aspRLabel = (<AspectRatioLabel width={width} height={height} classes={classes} style={rmStyle} />)
    }

    let printIcon = null;
    let plusIcon = null;
    let minusIcon = null;
    let countLabel = null;
    let sizeSelectIcon = null;

    if (printsEnabled && !isVideo) {

      // Updating img, container, and full size button styles first
      if (showPrintToggled) {
        cont.padding = '0.5rem';
        cont.border = '10px solid #ffbc00';

        if (selected) {
          // digital image is also selected
          imgStyle.border = '8px solid #ffb74d';

        } else {
          // digital image has already been purchased
          imgStyle.border = '8px solid #fff';
        }
      }

      // Determining print button styles
      let showStaticPrintIcon = !user.unlocked && attrs.photo.print_purchased && !multiPrint && !sizedPrint;
      if (showStaticPrintIcon) {
        // todo: allow purchasing further prints if multi print
        let printIconStyle = {
          color: '#fff',
          background: 'none',
          cursor: 'default'
        }

        if (multiPrint || sizedPrint) {
          printIconStyle.right = 0;
        } else {
          printIconStyle.left = 0;
          printIconStyle.fontSize = '3rem';
        }

        let checkStyle = {
          ...printIconStyle,
          marginLeft: '2.8rem',
          marginBottom: '1.2rem',
          fontSize: '2rem'
        }

        let tooltip = <FormattedMessage {...messages.kiosk_cart_image_tooltip_print_purchased} />;

        printIcon = (
          <span>
            <PrintIcon className={classes.printIcon} style={printIconStyle} title={tooltip} />
            <CheckIcon className={classes.printIcon} style={checkStyle} title={tooltip} />
          </span>
        );

      } else if (showPrintToggled) {
        let printIconStyle;

        if (multiPrint || isViewPhotos) {
          printIconStyle = {
            right: '140px'
          }
        } else if (sizedPrint) {
          printIconStyle = {
            right: 0
          }
        }
        else {
          printIconStyle = {
            left: '6px',
            fontSize: '3rem'
          }
        }

        let tooltip = <FormattedMessage {...messages.kiosk_image_tooltip_print_selected} />;

        printIcon = (
          <PrintIcon className={classes.printIcon} style={printIconStyle} onClick={this.onPrintIconClick.bind(this)} title={tooltip} />
        );

        if (multiPrint || isViewPhotos) {
          let addTooltip = <FormattedMessage {...messages.kiosk_image_tooltip_add_print} />;
          let removeTooltip = <FormattedMessage {...messages.kiosk_image_tooltip_remove_print} />;

          plusIcon = (
            <PlusIcon className={classes.plusIcon} onClick={this.addPrint.bind(this)} title={addTooltip} />
          )

          minusIcon = (
            <RemoveIcon className={classes.minusIcon} onClick={this.subtractPrint.bind(this)} title={removeTooltip} />
          )

          if (printCount > 0) {
            countLabel = (
              <div className={classes.countLabel}>{printCount}</div>
            )
          }
        }
        else {
          // folded size selection into main print icon, disabling for now
          //if (sizedPrint) {
          //  sizeSelectIcon = (
          //    <PhotoSizeSelectLargeIcon className={classes.sizeSelectIcon} onClick={this.selectMomentPrintSize.bind(this)} title={tooltip} />
          //  )
          //}
        }

      } else {
        let printIconStyle = {
          background: '#ffbc00',
          color: '#fff'
        };

        if (multiPrint || sizedPrint) {
          printIconStyle.right = 0;
        } else {
          printIconStyle.left = 0;
          printIconStyle.fontSize = '3rem';
        }

        let tooltip = <FormattedMessage {...messages.kiosk_image_tooltip_select_print} />;

        printIcon = (
          <PrintDisabledIcon className={classes.printIcon} style={printIconStyle} onClick={this.enablePrint.bind(this)} title={tooltip} />
        );
      }
    }

    // Utilized in Pre-Print gallery only
    let accessLabel = null;
    if (attrs.photo.customers && displayAccessCodes) {
      accessLabel = (<AccessCodeLabel classes={classes} customers={attrs.photo.customers} />)
    }

    return (
      <div
        ref={this.ref}
        style={cont}
        className={selected ? "not-selected" : ""}
      >
        {checkmark}
        {aspRLabel}
        {removeIcon}
        {fullscreenIcon}
        {printIcon}
        {sizeSelectIcon}
        {plusIcon}
        {minusIcon}
        {countLabel}
        {accessLabel}
        {img}
        {this.renderRemoveModal()}
        {this.renderSizeSelectionModal(attrs.photo.moment_id, attrs.photo.width, attrs.photo.height, attrs.photo.thumb_url, attrs.photo.purchased)}
      </div>
    );
  }
}

const mapStateToProps = state => ({
  settings: state.kioskReducer.settings,
  user: state.kioskReducer.user,
  view: state.kioskReducer.view,
  //selectedMomentIds: state.cartReducer.selectedMomentIds,
  selectedPrintMomentIds: state.cartReducer.selectedPrintMomentIds,
  selectedPrePrintMomentIds: state.kioskReducer.selectedPrintMomentIds,
  selectedPrintSizes: state.cartReducer.selectedPrintSizes
});

export default connect(mapStateToProps, { setPhotoSwipeOpen, setPhotoSwipeMoment, selectPrints, unselectPrints, selectPrePrints, unSelectPrePrints, viewVideo })(withStyles(styles)(Image));
